import { RedoBadge } from "@redotech/redo-web/arbiter-components/badge/redo-badge";
import { memo } from "react";

interface SubscriptionFrequencyBadgeProps {
  frequency?: number;
  intervalUnit?: "day" | "week" | "month";
}

export function getFrequencyText(
  frequency: number,
  unit: "day" | "week" | "month",
  includeEvery = false,
): string {
  const unitText = frequency === 1 ? unit : `${unit}s`;
  return includeEvery
    ? `Every ${frequency} ${unitText}`
    : `${frequency} ${unitText}`;
}

export const SubscriptionFrequencyBadge = memo(
  function SubscriptionFrequencyBadge({
    frequency,
    intervalUnit,
  }: SubscriptionFrequencyBadgeProps) {
    const formatFrequency = (
      freq?: number,
      unit?: "day" | "week" | "month",
    ) => {
      if (!freq || !unit) {
        return "N/A";
      }
      return getFrequencyText(freq, unit, true);
    };

    return (
      <RedoBadge
        color="blueLight"
        size="sm"
        text={formatFrequency(frequency, intervalUnit)}
      />
    );
  },
);
